import React, { useEffect, useState } from "react";
import ReportTablePage from "./ReportTablePage";
import { getContributionSummaryReport } from "../../services/api";

export default function ContributionSummaryReportPage() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    dateFrom: "",
    dateTo: "",
  });

  useEffect(() => {
    loadReport();
  }, []);

  const loadReport = async () => {
    try {
      setLoading(true);
      const res = await getContributionSummaryReport(filters);
      setRows(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error(err);
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  const clearFilters = () => {
    setFilters({
      dateFrom: "",
      dateTo: "",
    });
  };

  const formatMoney = (value) =>
    Number(value || 0).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  const columns = [
    {
      label: "Contribution Type",
      key: "contribution_type",
    },
    {
      label: "Transactions",
      key: "txn_count",
    },
    {
      label: "Total Amount",
      key: "total_amount",
      render: (row) => `TSH ${formatMoney(row.total_amount)}`,
      exportValue: (row) => `TSH ${formatMoney(row.total_amount)}`,
    },
    {
      label: "Average Amount",
      key: "average_amount",
      render: (row) => `TSH ${formatMoney(row.average_amount)}`,
      exportValue: (row) => `TSH ${formatMoney(row.average_amount)}`,
    },
  ];

  const filterNodes = (
    <>
      <div>
        <label className="field-label">Date From</label>
        <input
          type="date"
          className="input"
          value={filters.dateFrom}
          onChange={(e) => setFilters({ ...filters, dateFrom: e.target.value })}
        />
      </div>

      <div>
        <label className="field-label">Date To</label>
        <input
          type="date"
          className="input"
          value={filters.dateTo}
          onChange={(e) => setFilters({ ...filters, dateTo: e.target.value })}
        />
      </div>
    </>
  );

  return (
    <ReportTablePage
      title="Contribution Summary Report"
      // subtitle="Summary of collections by contribution type"
      filters={filterNodes}
      rows={rows}
      columns={columns}
      loading={loading}
      onSearch={loadReport}
      onClear={clearFilters}
      exportFileName="contribution_summary_report.csv"
    />
  );
}